var _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoxcidLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#paint0_linear_169_849)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_169_849",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_169_849)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_169_849)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.9999,
    cy: 18,
    r: 10.8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_169_849)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.3,
    cy: 21.9,
    r: 10.8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_169_849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5999 20.4349C33.5999 29.0506 26.6155 36.0349 17.9999 36.0349C9.38426 36.0349 2.3999 29.0506 2.3999 20.4349C2.3999 11.8193 17.9999 34.3806 17.9999 25.7649C17.9999 16.5349 33.5999 11.8193 33.5999 20.4349Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_169_849",
    x: -11.4667,
    y: -11.4667,
    width: 58.9334,
    height: 58.9333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.33333,
    result: "effect1_foregroundBlur_169_849"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_169_849",
    x: -25.1667,
    y: -15.5667,
    width: 74.9334,
    height: 74.9333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.3333,
    result: "effect1_foregroundBlur_169_849"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_169_849",
    x: -13.6001,
    y: -0.0999975,
    width: 63.1999,
    height: 52.1349,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_169_849"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_849",
    x1: 28.95,
    y1: 40.05,
    x2: 13.35,
    y2: -15.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221732,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390382,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#ECF4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoxcidLogo);
export default __webpack_public_path__ + "static/media/foxcid_logo.b9c3cfedf9b54ecbdf8203ea6bf65859.svg";
export { ForwardRef as ReactComponent };